import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from '../src/store/index'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Ls from './services/ls'
import {BASE_URL} from "@/services/api";
import i18n from "@/plugins/i18n";
import Vue3Toasity from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { toast } from 'vue3-toastify';


window.axios = axios
window.Ls = Ls

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
window.axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.baseURL = BASE_URL

window.axios.interceptors.request.use(function (config) {
// Exécuter ceci avant que la requête soit envoyée
    const AUTH_TOKEN = Ls.get('auth.token')
    if (AUTH_TOKEN) {
        config.headers.Authorization = `Bearer ${AUTH_TOKEN}`
    }
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})

window.axios.interceptors.response.use(undefined, function (err) {
    if (!err.response) {
        toast.error('Network error: Please check your internet connection or wait until servers are back online')
    } else {
        if (err.response.data && (err.response.statusText === 'Unauthorized' || err.response.data === ' Unauthorized.')) {
            toast.error((err.response.data.message) ? err.response.data.message : 'Unauthorized')
            Ls.remove('auth.token')
            Ls.remove('pseudo')
            Ls.remove('orders')
        } else if (err.response.data && err.response.status === 404 && Ls.get('auth.token')) {

        } else if (err.response.data && err.response.status === 403) {

        } else if (err.response.data.errors) {
            // Show a notification per error
            const errors = JSON.parse(JSON.stringify(err.response.data.errors))
            for (const i in errors) {
                toast.error(errors[i])
            }
        } else {
            // Unknown error
            toast.error((err.response.data.message) ? err.response.data.message : 'Unknown error occurred')
        }
    }
    // Do something with request error
    return Promise.reject(err)
})



const app = createApp(App)

app.use(VueAxios, axios)
app.use(router)
app.use(store)
app.use(i18n)
app.use( Vue3Toasity, {autoClose: 3000 })

app.mount('#app')

